import clsx from 'clsx';

interface ExecutionTimeProps {
    className?: string;
    label?: string;
    time: number;
}

// The time prop and both thresholds are in milliseconds.
const WARNING_THRESHOLD = 50;
const DANGER_THRESHOLD = 200;

const ExecutionTime = ({
    className,
    time,
    label = 'Execution time'
}: ExecutionTimeProps) => {
    let cls = 'text-green-8';
    if (time > WARNING_THRESHOLD) {
        cls = 'text-orange-4';
    }
    if (time > DANGER_THRESHOLD) {
        cls = 'text-red-8';
    }
    return (
        <div className={clsx(cls, className)}>
            {label}: {time} ms
        </div>
    );
};

export default ExecutionTime;
